import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found-error',
  templateUrl: './page-not-found-error.component.html',
  styleUrls: ['./page-not-found-error.component.css']
})
export class PageNotFoundErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
